export default __webpack_public_path__ + "static/media/layers.1d2b87d2.svg";